"use strict";
exports.__esModule = true;
exports.evaluationNormedTools = exports.AssessmentMethod = void 0;
var AssessmentMethod;
(function (AssessmentMethod) {
    AssessmentMethod["NORMALIZED_TOOLS"] = "normed-tools-tests";
    AssessmentMethod["VISION"] = "vision-evaluation";
    AssessmentMethod["HEARING"] = "hearing-evaluation";
    AssessmentMethod["CAREGIVER"] = "caregiver-report";
    AssessmentMethod["CLINICAL_OBSERVATION"] = "clinical-observation";
    AssessmentMethod["MEDICAL_RECORD"] = "medical-records";
    AssessmentMethod["EDUCATIONAL_RECORD"] = "educational-records";
    AssessmentMethod["OTHER"] = "other";
})(AssessmentMethod = exports.AssessmentMethod || (exports.AssessmentMethod = {}));
exports.evaluationNormedTools = [
    'Developmental Assessment of Young Children (DAYC)',
    'Devereux Early Childhood Assessment Infant and Toddler (DECA-IT)',
    'Devereux Early Childhood Assessment Clinical (DECA-C)',
    'Bayley Scales of Infant and Toddler Development (Bayley)',
    'Preschool Language Scale (PLS)',
    'Battelle Developmental Inventory (BDI)',
    'Peabody Developmental Motor Scales (PDMS)',
    'Temperament & Atypical Behavior Scale (TABS)  Assessment Tool',
    'Receptive-Expressive Emergent Language Scale (REEL)',
    'Rossetti Infant-Toddler Language Scale',
    'Toddler and Infant Motor Evaluation (TIME)',
    'Vineland Adaptive Behavior Scales (Vineland)',
    'Goldman-Fristoe Test of Articulation (GFTA)',
    'Infant Toddler Sensory Profile',
    'Hawaii Early Learning Profile (HELP)',
    'Assessment, Evaluation, and Programming System (AEPS) For Birth to three Years',
    'Adaptive Behavior Assessment System (ABAS)',
    'MacArthur-Bates Communicative Development Inventories (CDI)',
    'Receptive One-Word Picture vocabulary Test (ROWPVT)',
    'Peabody Picture Vocabulary Test (PPVT)',
    'Test of Early Language Development (TELD)',
    'Achenbach System of Empirically Based Assessment (ASEBA)',
    'Arizona Articulation Proficiency Scale',
    'Behavior Assessment System for Children (BASC)',
    'Brigance Diagnostic Inventory of Early Development (IED)',
    'Creative Curriculum Developmental Continuum for Infants, Toddlers and Twos',
    'Differential Ability Scales (DAS)',
    'High/Scope Child Observation Record for Infants and Toddlers (COR-IT)',
    'Learning Accomplishment Profile-Diagnostic (LAP-D)',
    'Stanford-Binet Intelligence Scales for Early Childhood (Early SB)',
    'Carolina Curriculum for Infants and Toddlers with Special Needs (CCITSN)',
    'Other',
].map(function (label, index) { return ({
    id: (index + 1).toString(),
    label: label
}); });
//# sourceMappingURL=Evaluation.js.map